import React, { Component } from "react";
import { connect } from "react-redux";
import { View, ScrollView } from "react-native";
import Text from "../../components_v2/TextFont";
import { ArButton } from "../../argon-ui";

import Theme from "../../argon-ui/Theme";

import { translate } from "../../locales/translate";

import SearchableDropdown from "../SearchableDropDown";
import * as AreaHelper from "../../actions/AreaHelper";
import { ScenarioDeviceStateCondition } from "../../viewModels/Scenario";
import InputBase from "../../nativeBase-ui/InputBase";
import ConditionEventLayout from "./ConditionEventLayout";
import TabBase from "../../nativeBase-ui/TabBase";

class OptionalConditionDeviceStateGenerator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedGroup: "",
      selectedDeviceId: 0,
      selectedDeviceName: "",
      selectedState: "",
      searchedDeviceName: "",

      areaId: this.props.areaId || 0,
      areaUId: this.props.areaUId || null,
      areaName: this.props.areaName || "",
      errorMessage: "",

      listener: "",
      state: "",
      deviceId: undefined,
      deviceName: "",
      deviceType: "",
      argTypes: [],
      argNames: [],
      argValues: [],
      tab: "tabSingleDeviceState", // abSingleDeviceState | abSingleDeviceState
    };
    this.allTypes = [];
    this.allTypesDropdown = [];

    this.deviceDropdownList = [];

    this.statesListDropdown = [];
    this.listeners = [];

    this.listenerSingleStates = [];
    this.listenerBatchStates = [];

    this.listenerSensors = [];
    this.tabs = ["tabBatchAreaState", "tabSingleDeviceState"];
  }

  componentDidMount() {
    this.props.deviceReducer.list.map((d, i) => {
      if (this.allTypes.indexOf(d.deviceType) < 0) {
        this.allTypes.push(d.deviceType);
        this.allTypesDropdown.push({
          id: d.deviceType,
          name: translate(`deviceGroup.${d.deviceType}`),
        });
      }
    });

    this.props.areaReducer.eventListeners.map((l, i) => {
      if (l.states && l.states.length > 0) {
        this.listeners.push({
          id: l.listener,
          name: translate(`scenario.${l.listener}`),
        });
      }
    });
  }

  onListenerSelect = (listener) => {
    var listenerModel = this.findListenerByName(listener);

    for (var i in listenerModel.states) {
      var item = {
        id: listenerModel.states[i].state,
        name: translate(`scenario.${listenerModel.states[i].state}`),
      };
      if (listenerModel.states[i].isBatchState) {
        this.listenerBatchStates.push(item);
      } else {
        this.listenerSingleStates.push(item);
      }
    }

    // reset devices dropdown
    this.listenerSensors = [];
    var area = AreaHelper.findAreaById(
      this.props.areaReducer.areas,
      this.state.areaId || this.state.areaUId
    );
    if (area && Array.isArray(area.devices) && area.devices.length) {
      let allDevices = this.props.deviceReducer.list;
      const _areaDevices = area.devices ? area.devices : area.uDevices;
      for (var i in _areaDevices) {
        for (var j in allDevices) {
          const _devices = _areaDevices[i];
          if (
            (_devices == allDevices[j].deviceId ||
              _devices == allDevices[j].deviceUId) &&
            listenerModel.deviceType
              .split(",")
              .indexOf(allDevices[j].deviceType) >= 0
          ) {
            this.listenerSensors.push({
              id: allDevices[j].deviceId || allDevices[j].deviceUId,
              name: allDevices[j].deviceName,
            });
          }
        }
      }
    }

    // set manager name and clear action with its parameters.
    this.setState({
      listener,
      state: "",
      argTypes: [],
      argNames: [],
      argValues: [],
    });
  };

  onListenerClear = () => {
    this.onStateClear();
    this.listenerBatchStates = [];
    this.listenerSingleStates = [];
    this.listenerSensors = [];
    this.setState({
      listener: "",
      state: "",
      argTypes: [],
      argNames: [],
      argValues: [],
    });
  };

  onStateSelect = (state) => {
    var listenerModel = this.findListenerByName(this.state.listener);
    var _argTypes = [],
      _argNames = [],
      _argValues = [];
    if (
      listenerModel &&
      listenerModel.states &&
      listenerModel.states.length > 0
    ) {
      for (var i in listenerModel.states) {
        if (listenerModel.states[i].state == state) {
          var stateModel = listenerModel.states[i];
          if (stateModel.argTypes && stateModel.argTypes.length) {
            for (var j in stateModel.argTypes) {
              var pt = stateModel.argTypes[j];
              _argTypes.push(pt);
              _argNames.push(stateModel.argNames[j]);
              switch (pt) {
                case "bool":
                  _argValues.push(false); //default for boolean (like toggles,...)
                  break;
                case "int":
                case "int32":
                case "short":
                  _argValues.push(0); //default for numbers
                  break;
                case "byte":
                  _argValues.push(128); //default for sliders (like dimmer lights,...) 128 in bytes equals 50%
                  break;
                default: //default for unknown
                  _argValues.push("");
                  break;
              }
            }
            break;
          }
        }
      }
    }

    this.setState({
      state: state,
      deviceType: listenerModel.deviceType,
      argTypes: _argTypes,
      argNames: _argNames,
      argValues: _argValues,
    });
  };

  onStateClear = () => {
    this.setState({
      state: "",
      argTypes: [],
      argNames: [],
      argValues: [],
    });
  };

  findListenerByName = (listenerName) => {
    let { eventListeners } = this.props.areaReducer;
    for (var i in eventListeners) {
      if (eventListeners[i].listener == listenerName) {
        return eventListeners[i];
      }
    }
  };

  handleOnConfirm = () => {
    if (!this.props.onConfirm) {
      return;
    }

    var listenerModel = {};
    var stateModel = {};

    listenerModel = this.findListenerByName(this.state.listener);

    for (var j in listenerModel.states) {
      if (listenerModel.states[j].state == this.state.state) {
        stateModel = listenerModel.states[j];
        break;
      }
    }
    // ===  find devices selected by deviceId or deviceUId ===
    const _devices = this.props.deviceReducer.list.find(
      (device) =>
        device.deviceId == this.state.deviceId ||
        device.deviceUId == this.state.deviceId
    );
    var result = new ScenarioDeviceStateCondition();
    result.deviceId = _devices?.deviceId;
    result.deviceUId = _devices?.deviceUId;
    result.deviceName = this.state.deviceName;
    result.deviceType = this.state.deviceType;
    result.listenerName = this.state.listener;
    result.stateName = this.state.state;
    result.areaId = this.state.areaId;
    result.areaUId = this.state.areaUId;
    result.areaName = this.state.areaName;
    result.argNames = this.state.argNames;
    result.argValues = this.state.argValues;

    // console.log(
    //   "result in OptionalConditionDeviceStateGenerator.onConfirm()",
    //   result
    // );
    this.props.onConfirm && this.props.onConfirm(result);
  };

  handleTabChange = (tab) => {
    this.setState(
      {
        tab,
        event: "",
        deviceId: undefined,
        deviceUId: undefined,
        argTypes: [],
        argNames: [],
        argValues: [],
      },
      () => {}
    );
  };

  render() {
    return (
      <View style={this.props.style || { flex: 1, paddingTop: 10 }}>
        <ConditionEventLayout
          title={translate("scenario.deviceState")}
          subTitle={
            translate("scenario.deviceStatesOfArea") +
            `"${this.state.areaName}"`
          }
        >
          {/* listeners dropdown */}
          <SearchableDropdown
            label={translate("device.deviceType")}
            items={this.listeners}
            clearable={true}
            onSelect={this.onListenerSelect}
            onClear={this.onListenerClear}
            style={{ width: "100%", alignSelf: "center" }}
          />
          <TabBase
            containerStyle={{ marginVertical: 10 }}
            tab={this.state.tab}
            tabs={this.tabs}
            handleChange={(tab) => this.handleTabChange(tab)}
          >
            {/* batch form */}
            {this.state.tab == "tabBatchAreaState" && (
              <View>
                <SearchableDropdown
                  clearable={true}
                  label={translate("scenario.states")}
                  noItemText={translate("scenario.pickCategoryFirst")}
                  items={this.listenerBatchStates}
                  onSelect={this.onStateSelect}
                  onClear={this.onStateClear}
                />
              </View>
            )}
            {/* single form */}
            {this.state.tab == "tabSingleDeviceState" && (
              <View>
                <SearchableDropdown
                  clearable={true}
                  label={translate("scenario.device")}
                  noItemText={
                    !this.state.listener
                      ? translate("scenario.pickCategoryFirst")
                      : undefined
                  }
                  items={this.listenerSensors}
                  onSelect={(deviceId, deviceName) =>
                    this.setState({ deviceId, deviceName })
                  }
                  onClear={() =>
                    this.setState({
                      deviceId: undefined,
                      deviceUId: undefined,
                      deviceName: undefined,
                    })
                  }
                />
                <SearchableDropdown
                  clearable={true}
                  label={translate("scenario.states")}
                  items={
                    this.state.deviceId ? this.listenerSingleStates : undefined
                  }
                  noItemText={
                    !this.state.listener
                      ? translate("scenario.pickCategoryFirst")
                      : !this.state.deviceId
                      ? translate("scenario.pickDeviceFirst")
                      : "---"
                  }
                  onSelect={this.onStateSelect}
                  onClear={this.onStateClear}
                />
              </View>
            )}
          </TabBase>
          {/* inputs */}
          <ScrollView
            style={{ paddingHorizontal: 5 }}
            persistentScrollbar={true}
          >
            {this.state.argTypes &&
              this.state.argTypes.length > 0 &&
              this.state.argTypes.map((pt, i) => {
                var pn = this.state.argNames[i];
                if (pt == "int" || pt == "int32" || pt == "short")
                  return (
                    <InputBase
                      key={i}
                      containerStyle={{ width: "96%", alignSelf: "center" }}
                      keyboardType="numeric"
                      label={
                        translate(`scenario.${pn}`) +
                        "(" +
                        translate(`scenario.stateParamUnits.${pn}`) +
                        ")"
                      }
                      onChangeText={(txt) => {
                        var values = this.state.argValues;
                        if (values && values.length > i) {
                          values[i] = Number(txt) || 0;
                          this.setState({ argValues: values });
                        }
                      }}
                      value={Number(this.state.argValues[i]) || 0}
                    />
                  );
                else
                  return (
                    <InputBase
                      key={i}
                      label={
                        translate(`scenario.${pn}`) +
                        "(" +
                        translate(`scenario.stateParamUnits.${pn}`) +
                        ")"
                      }
                      placeholder=""
                      value={this.state.argValues[i]}
                      onChangeText={(txt) => {
                        var values = this.state.argValues;
                        if (values && values.length > i) {
                          values[i] = txt;
                          this.setState({ argValues: values });
                        }
                      }}
                    />
                  );
              })}
          </ScrollView>
          {/* end of inputs */}
          {/* continue button */}
          <Text
            style={{
              color: Theme.COLORS.ERROR,
              alignSelf: "center",
              paddingTop: 20,
            }}
          >
            {this.state.errorMessage}
          </Text>
        </ConditionEventLayout>
        <ArButton
          color="primary"
          style={{ width: "100%", alignSelf: "center" }}
          onPress={this.handleOnConfirm}
        >
          <Text style={{ color: "#FFF" }}>{translate("app.continue")}</Text>
        </ArButton>

        {/* end of continue button */}
      </View>
    );
  }
}

const mapStateToProps = (state) => {
  return { deviceReducer: state.DeviceReducer, areaReducer: state.AreaReducer };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OptionalConditionDeviceStateGenerator);
